const carouselItems = [
  {
    title: '暑期档 · 票房冠军精选',
    desc: '院线热门大片第一时间上线，这个夏天不容错过的视听盛宴。从《封神第一部》到《消失的她》，高分佳作免费看全集。',
    tag: '专题推荐',
    imgUrl: 'https://readdy.ai/api/search-image?query=Summer%20movie%20marathon%20concept%20with%20cinematic%20film%20elements%2C%20warm%20golden%20sunset%20lighting%2C%20movie%20posters%20floating%20in%20artistic%20composition%2C%20popcorn%20and%20film%20reel%20accents%2C%20vibrant%20and%20exciting%20atmosphere%2C%20professional%20cinematography%20aesthetic&width=900&height=500&seq=carousel-1-summer&orientation=landscape',
  },
  {
    title: '国剧崛起 · 口碑神作合集',
    desc: '《狂飙》《漫长的季节》《三体》——国产剧迎来黄金时代。演技、剧本、制作全面升级，每一部都值得细细品味。',
    tag: '编辑精选',
    imgUrl: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20showcase%20with%20dramatic%20urban%20and%20historical%20scenes%20blended%2C%20actor%20silhouettes%20in%20cinematic%20lighting%2C%20premium%20production%20quality%20visual%2C%20dark%20and%20warm%20tone%20contrast%2C%20professional%20film%20poster%20design%2C%20powerful%20emotional%20impact&width=900&height=500&seq=carousel-2-chinadrama&orientation=landscape',
  },
  {
    title: '悬疑烧脑 · 高能反转片单',
    desc: '从国产悬疑到韩剧复仇，精选全网高能反转神作。《黑暗荣耀》《漫长的季节》《隐秘的角落》，猜不到结局才过瘾。',
    tag: '热门专题',
    imgUrl: 'https://readdy.ai/api/search-image?query=Mystery%20and%20suspense%20film%20theme%20with%20dark%20atmospheric%20lighting%2C%20shadowy%20figures%20and%20dramatic%20contrast%2C%20moody%20blue%20and%20amber%20color%20palette%2C%20detective%20noir%20inspired%20aesthetic%2C%20cinematic%20tension%20and%20intrigue%2C%20professional%20film%20poster%20style&width=900&height=500&seq=carousel-3-suspense&orientation=landscape',
  },
  {
    title: '全家欢 · 亲子观影指南',
    desc: '精选适合全家一起观看的电影和动画。从经典迪士尼到国产动画，温馨有趣的亲子时光从51影视开始。',
    tag: '家庭精选',
    imgUrl: 'https://readdy.ai/api/search-image?query=Family%20movie%20night%20concept%20with%20warm%20cozy%20atmosphere%2C%20animated%20film%20elements%20and%20colorful%20characters%2C%20soft%20warm%20lighting%20with%20popcorn%20and%20blanket%2C%20joyful%20and%20heartwarming%20vibe%2C%20cinematic%20family%20entertainment%20theme%2C%20bright%20and%20cheerful%20composition&width=900&height=500&seq=carousel-4-family&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              深度策划，发现更多好内容
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {carouselItems.map((item) => (
              <div
                key={item.title}
                className="group relative rounded-xl overflow-hidden bg-background-900 cursor-pointer"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={item.imgUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium bg-accent-500 text-white rounded-full mb-3">
                    {item.tag}
                  </span>
                  <h3 className="text-lg md:text-xl font-bold text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-white/70 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}